module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('h1', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n        " + _vm._s(_vm.isEdit ? ((_vm.$lang.actions.edit) + " " + (_vm.company.name)) :
    _vm.$lang.labels.createCompany) + "\n      ")]), _vm._v(" "), (!_vm.isEdit && !_vm.isLocalAdmin) ? _c('div', {
    staticClass: "d-inline-flex"
  }, [(_vm.showCompanies) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pr-3"
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    on: {
      "click": function($event) {
        return _vm.fetchAllCompanies()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.importCompany))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.header.companyGeneralData) + "\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.name,
      "placeholder": _vm.$lang.placeholders.companyName,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyName)); }],
      "type": "text",
      "id": "name",
      "required": "",
      "hint": _vm.company.name.length > 12 ? 'Name will be shortened on webshop in mobile view' : '',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.email,
      "placeholder": _vm.$lang.placeholders.companyEmail,
      "type": "email",
      "id": "email",
      "required": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.company.email),
      callback: function($$v) {
        _vm.$set(_vm.company, "email", $$v)
      },
      expression: "company.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationNumber,
      "type": "text",
      "id": "registrationNumber"
    },
    model: {
      value: (_vm.company.registrationNumber),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationNumber", $$v)
      },
      expression: "company.registrationNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.phone,
      "placeholder": _vm.$lang.placeholders.phone,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyPhone)); }],
      "required": "",
      "type": "text",
      "id": "phone"
    },
    model: {
      value: (_vm.company.phone),
      callback: function($$v) {
        _vm.$set(_vm.company, "phone", $$v)
      },
      expression: "company.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.registrationLocation,
      "type": "text",
      "id": "registrationLocation"
    },
    model: {
      value: (_vm.company.registrationLocation),
      callback: function($$v) {
        _vm.$set(_vm.company, "registrationLocation", $$v)
      },
      expression: "company.registrationLocation"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "required",
    attrs: {
      "rules": [_vm.company.cuisines.length !== 0 || ("" + (_vm.$lang.errors.missingCuisines))],
      "required": "",
      "multiple": "",
      "small-chips": "",
      "deletable-chips": "",
      "items": _vm.cuisines,
      "label": _vm.$lang.labels.cuisines
    },
    model: {
      value: (_vm.company.cuisines),
      callback: function($$v) {
        _vm.$set(_vm.company, "cuisines", $$v)
      },
      expression: "company.cuisines"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.companySettings) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "currency-wrap",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "required pb-2 mb-1",
    attrs: {
      "label": _vm.$lang.labels.currency,
      "items": _vm.currencies,
      "name": "currency",
      "id": "currency",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCurrency)); }],
      "required": ""
    },
    model: {
      value: (_vm.company.currency),
      callback: function($$v) {
        _vm.$set(_vm.company, "currency", $$v)
      },
      expression: "company.currency"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "radio-input",
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.align) + ":")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.align),
      callback: function($$v) {
        _vm.align = $$v
      },
      expression: "align"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$lang.labels.left,
      "value": "left",
      "color": "primary"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$lang.labels.right,
      "value": "right",
      "color": "primary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.defLang,
      "items": _vm.languages,
      "item-text": "text",
      "item-value": "value",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingLang)); }]
    },
    model: {
      value: (_vm.company.defaultLanguage),
      callback: function($$v) {
        _vm.$set(_vm.company, "defaultLanguage", $$v)
      },
      expression: "company.defaultLanguage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pr-2": ""
    }
  }, [_c('v-select', {
    staticClass: "required pb-2 mb-1",
    attrs: {
      "label": _vm.$lang.labels.distanceUnit,
      "placeholder": _vm.$lang.placeholders.distanceUnit,
      "items": _vm.distanceUnits,
      "disabled": _vm.distanceUnits.length <= 0,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingdistanceUnit)); }]
    },
    model: {
      value: (_vm.company.distanceUnit),
      callback: function($$v) {
        _vm.$set(_vm.company, "distanceUnit", $$v)
      },
      expression: "company.distanceUnit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pl-2": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.timezone,
      "placeholder": _vm.$lang.labels.timezone,
      "items": _vm.timezones,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingTimezone)); }]
    },
    model: {
      value: (_vm.company.timezone),
      callback: function($$v) {
        _vm.$set(_vm.company, "timezone", $$v)
      },
      expression: "company.timezone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.bookKeeperEmails,
      "type": "text",
      "id": "bookKeeperEmails"
    },
    model: {
      value: (_vm.bookKeeperEmails),
      callback: function($$v) {
        _vm.bookKeeperEmails = $$v
      },
      expression: "bookKeeperEmails"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.pricingGroups,
      "placeholder": _vm.$lang.placeholders.pricingGroups,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "items": _vm.mappedGroups,
      "disabled": _vm.mappedGroups.length <= 0,
      "required": "",
      "rules": [_vm.company.pricingGroups.length > 0 || ("" + (_vm.$lang.errors.missingPricingGroups))]
    },
    model: {
      value: (_vm.company.pricingGroups),
      callback: function($$v) {
        _vm.$set(_vm.company, "pricingGroups", $$v)
      },
      expression: "company.pricingGroups"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.fetchConf,
      "rules": [function (v) { return _vm.company.config_update_frequency_in_minutes.toString().length > 0 || ("" + (_vm.$lang.errors.missingFetchConf)); }],
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.company.config_update_frequency_in_minutes),
      callback: function($$v) {
        _vm.$set(_vm.company, "config_update_frequency_in_minutes", $$v)
      },
      expression: "company.config_update_frequency_in_minutes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.company.companyRandomId) ? _c('p', {
    staticClass: "px-3 pb-3 id-for-s3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.idForS3) + ": " + _vm._s(_vm.company.companyRandomId))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "pb-2": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.testMode
    },
    model: {
      value: (_vm.company.test),
      callback: function($$v) {
        _vm.$set(_vm.company, "test", $$v)
      },
      expression: "company.test"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.dailyOrdersCounterEnabled
    },
    model: {
      value: (_vm.company.dailyOrdersCounterEnabled),
      callback: function($$v) {
        _vm.$set(_vm.company, "dailyOrdersCounterEnabled", $$v)
      },
      expression: "company.dailyOrdersCounterEnabled"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.enquiryReser
    },
    model: {
      value: (_vm.company.enableReservationForm),
      callback: function($$v) {
        _vm.$set(_vm.company, "enableReservationForm", $$v)
      },
      expression: "company.enableReservationForm"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.payIntegModule,
      "placeholder": _vm.$lang.placeholders.payIntegModule,
      "items": _vm.paymentGateways,
      "disabled": _vm.paymentGateways.length <= 0
    },
    model: {
      value: (_vm.company.paymentIntegration),
      callback: function($$v) {
        _vm.$set(_vm.company, "paymentIntegration", $$v)
      },
      expression: "company.paymentIntegration"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.enquiryContact
    },
    model: {
      value: (_vm.company.enableContactForm),
      callback: function($$v) {
        _vm.$set(_vm.company, "enableContactForm", $$v)
      },
      expression: "company.enableContactForm"
    }
  }), _vm._v(" "), (_vm.company.enableReservationForm) ? _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "type": "number",
      "min": "1",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMinPersons)); }],
      "label": _vm.$lang.labels.minPersons
    },
    model: {
      value: (_vm.company.minPersons),
      callback: function($$v) {
        _vm.$set(_vm.company, "minPersons", $$v)
      },
      expression: "company.minPersons"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.orderPrint
    },
    model: {
      value: (_vm.company.completePrint),
      callback: function($$v) {
        _vm.$set(_vm.company, "completePrint", $$v)
      },
      expression: "company.completePrint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "hide-details": "",
      "color": "primary",
      "label": _vm.$lang.labels.enableKitchenPrintPersistence
    },
    model: {
      value: (_vm.company.persistKitchenPrint),
      callback: function($$v) {
        _vm.$set(_vm.company, "persistKitchenPrint", $$v)
      },
      expression: "company.persistKitchenPrint"
    }
  }), _vm._v(" "), (_vm.company.enableReservationForm) ? _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "type": "number",
      "min": "1",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMaxPersons)); }],
      "label": _vm.$lang.labels.maxPersons
    },
    model: {
      value: (_vm.company.maxPersons),
      callback: function($$v) {
        _vm.$set(_vm.company, "maxPersons", $$v)
      },
      expression: "company.maxPersons"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [(_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.swithcCode,
      "type": "number",
      "min": "0",
      "max": "9999",
      "mask": "####",
      "hint": _vm.$lang.labels.swithcCodeHint
    },
    model: {
      value: (_vm.company.tableSwitchCode),
      callback: function($$v) {
        _vm.$set(_vm.company, "tableSwitchCode", $$v)
      },
      expression: "company.tableSwitchCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.tableIdleTimeInMinutes,
      "type": "number",
      "min": "0",
      "max": "120",
      "required": "",
      "rules": [function (v) { return (_vm.company.tableIdleTimeInMinutes !== null && _vm.company.tableIdleTimeInMinutes.toString().length > 0) ||
        ("" + (_vm.$lang.errors.missingTableMin)); }
      ]
    },
    model: {
      value: (_vm.company.tableIdleTimeInMinutes),
      callback: function($$v) {
        _vm.$set(_vm.company, "tableIdleTimeInMinutes", $$v)
      },
      expression: "company.tableIdleTimeInMinutes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.paymentTypes,
      "placeholder": _vm.$lang.placeholders.paymentTypes,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "items": _vm.payments,
      "required": "",
      "rules": [_vm.company.paymentTypes.length > 0 || ("" + (_vm.$lang.errors.missingPayments))]
    },
    model: {
      value: (_vm.company.paymentTypes),
      callback: function($$v) {
        _vm.$set(_vm.company, "paymentTypes", $$v)
      },
      expression: "company.paymentTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.companyAddress) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.country,
      "placeholder": _vm.$lang.placeholders.companyCountry,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyCountry)); }],
      "items": _vm.countries,
      "type": "text",
      "id": "country",
      "required": ""
    },
    model: {
      value: (_vm.company.address.country),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "country", $$v)
      },
      expression: "company.address.country"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.postalcode,
      "placeholder": _vm.$lang.placeholders.companyPostal,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyPostal)); }],
      "type": "text",
      "id": "postalcode",
      "required": ""
    },
    model: {
      value: (_vm.company.address.postalCode),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "postalCode", $$v)
      },
      expression: "company.address.postalCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.townCity,
      "placeholder": _vm.$lang.placeholders.companyTown,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyTown)); }],
      "type": "text",
      "id": "town",
      "required": ""
    },
    model: {
      value: (_vm.company.address.townCity),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "townCity", $$v)
      },
      expression: "company.address.townCity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.locality,
      "placeholder": _vm.$lang.placeholders.companyLocality,
      "type": "text",
      "id": "locality"
    },
    model: {
      value: (_vm.company.address.locality),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "locality", $$v)
      },
      expression: "company.address.locality"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0 mb-4",
    attrs: {
      "disabled": _vm.company.address.country === ''
    },
    on: {
      "click": function($event) {
        _vm.addressDialog = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.addressLookup))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.latitude,
      "rules": _vm.latitudeRule,
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.company.address.latitude),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "latitude", $$v)
      },
      expression: "company.address.latitude"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.longitude,
      "rules": _vm.latitudeRule,
      "type": "text"
    },
    model: {
      value: (_vm.company.address.longitude),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "longitude", $$v)
      },
      expression: "company.address.longitude"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 1',
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompanyAddress)); }],
      "type": "text",
      "id": "address1",
      "required": ""
    },
    model: {
      value: (_vm.company.address.line1),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line1", $$v)
      },
      expression: "company.address.line1"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 2',
      "type": "text",
      "id": "address2"
    },
    model: {
      value: (_vm.company.address.line2),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line2", $$v)
      },
      expression: "company.address.line2"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 3',
      "type": "text",
      "id": "address3"
    },
    model: {
      value: (_vm.company.address.line3),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line3", $$v)
      },
      expression: "company.address.line3"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.addressLine + ' 4',
      "type": "text",
      "id": "address4"
    },
    model: {
      value: (_vm.company.address.line4),
      callback: function($$v) {
        _vm.$set(_vm.company.address, "line4", $$v)
      },
      expression: "company.address.line4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingHours
    },
    on: {
      "click": _vm.addHours
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.openingHours))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [(_vm.openingTimes.length !== 0) ? _c('thead', [_c('tr', [_c('td', {
    staticClass: "move-row"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.day)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.start)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.end)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])])])]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.openingTimes), function(time, index) {
    return _c('tr', {
      key: index
    }, [(time.isEdit) ? [_c('td', {
      staticClass: "move-row"
    }), _vm._v(" "), _c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.days
      },
      model: {
        value: (_vm.tempOpening.day),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "day", $$v)
        },
        expression: "tempOpening.day"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.start),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "start", $$v)
        },
        expression: "tempOpening.start"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "required",
      attrs: {
        "type": "text",
        "mask": "##:##",
        "placeholder": "HH:mm",
        "required": "",
        "rules": _vm.timeRule
      },
      model: {
        value: (_vm.tempOpening.end),
        callback: function($$v) {
          _vm.$set(_vm.tempOpening, "end", $$v)
        },
        expression: "tempOpening.end"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.saveOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.save) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.openingValidation
      },
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.copy) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.cancel) + "\n                      ")])], 1)] : [_c('td', {
      staticClass: "move-row"
    }, [(_vm.openingTimes.length >= 2) ? _c('div', [(index !== 0) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveUp(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_up")]) : _vm._e(), _vm._v(" "), (index != _vm.openingTimes.length - 1) ? _c('v-icon', {
      on: {
        "click": function($event) {
          return _vm.moveDown(_vm.openingTimes, index)
        }
      }
    }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.day))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.end))]), _vm._v(" "), _c('td', {
      staticClass: "px-0",
      staticStyle: {
        "min-width": "314px"
      }
    }, [_c('v-btn', {
      staticClass: "primary elevation-1 mx-0",
      attrs: {
        "disabled": _vm.editingHours
      },
      on: {
        "click": function($event) {
          return _vm.editOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.edit) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.copyOpening(time)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.copy) + "\n                      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error mx-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteOpening(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$lang.actions.delete) + "\n                      ")])], 1)]], 2)
  }), 0)])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-2": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary ml-0 mr-3",
    attrs: {
      "disabled": _vm.editingVat || _vm.noTax
    },
    on: {
      "click": _vm.addVat
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.addVat) + "\n          ")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.noVATtax,
      "hide-details": "",
      "color": "primary"
    },
    model: {
      value: (_vm.noTax),
      callback: function($$v) {
        _vm.noTax = $$v
      },
      expression: "noTax"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.vatRates), function(vat, index) {
    return _c('tr', {
      key: index
    }, [(vat.isEdit) ? [_c('td', [_c('v-text-field', {
      staticClass: "min-w mb-2 required",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.01",
        "required": "",
        "hide-details": "",
        "label": _vm.$lang.actions.addVat
      },
      model: {
        value: (_vm.tempVat.vat),
        callback: function($$v) {
          _vm.$set(_vm.tempVat, "vat", $$v)
        },
        expression: "tempVat.vat"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempVat.vat
      },
      on: {
        "click": function($event) {
          return _vm.saveVatEdit(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeVatEdit(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(vat.vat))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editVat(vat)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteVat(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.tipTax,
      "items": _vm.vatRates,
      "type": "number",
      "step": "0.5",
      "min": "0",
      "disabled": _vm.noTipTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.tipTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "tipTaxRate", $$v)
      },
      expression: "company.tipTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noTipTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noTipTax),
      callback: function($$v) {
        _vm.noTipTax = $$v
      },
      expression: "noTipTax"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.chargeTax,
      "items": _vm.vatRates,
      "disabled": _vm.noDeliveryTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.deliveryChargesTaxRate),
      callback: function($$v) {
        _vm.$set(_vm.company, "deliveryChargesTaxRate", $$v)
      },
      expression: "company.deliveryChargesTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$lang.labels.noDeliveryTax,
      "hide-details": "",
      "disabled": this.vatRates.length === 0,
      "color": "primary"
    },
    model: {
      value: (_vm.noDeliveryTax),
      callback: function($$v) {
        _vm.noDeliveryTax = $$v
      },
      expression: "noDeliveryTax"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.actions.serviceType,
      "items": _vm.serviceTypes,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.company.serviceCharges.type),
      callback: function($$v) {
        _vm.$set(_vm.company.serviceCharges, "type", $$v)
      },
      expression: "company.serviceCharges.type"
    }
  })], 1), _vm._v(" "), (_vm.company.serviceCharges.type === 'percoftotal') ? [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$lang.labels.serviceTaxRate,
      "items": _vm.vatRates,
      "disabled": _vm.noServiceTax,
      "item-text": "vat",
      "item-value": "vat"
    },
    model: {
      value: (_vm.company.serviceCharges.taxRate),
      callback: function($$v) {
        _vm.$set(_vm.company.serviceCharges, "taxRate", $$v)
      },
      expression: "company.serviceCharges.taxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.vatRates.length === 0,
      "label": _vm.$lang.labels.noServiceTax,
      "hide-details": "",
      "color": "primary"
    },
    model: {
      value: (_vm.noServiceTax),
      callback: function($$v) {
        _vm.noServiceTax = $$v
      },
      expression: "noServiceTax"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "label": _vm.$lang.labels.percOfTotal
    },
    model: {
      value: (_vm.company.serviceCharges.percOfTotal),
      callback: function($$v) {
        _vm.$set(_vm.company.serviceCharges, "percOfTotal", $$v)
      },
      expression: "company.serviceCharges.percOfTotal"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.delivery) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": ((_vm.$lang.labels.maxDist) + " (" + (_vm.company.distanceUnit) + ")"),
      "required": "",
      "type": "number",
      "step": "0.5",
      "min": "0",
      "rules": _vm.distanceRule
    },
    model: {
      value: (_vm.company.maxDeliveryDistance),
      callback: function($$v) {
        _vm.$set(_vm.company, "maxDeliveryDistance", $$v)
      },
      expression: "company.maxDeliveryDistance"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.delPostal,
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.company.deliveryPostalCodes),
      callback: function($$v) {
        _vm.$set(_vm.company, "deliveryPostalCodes", $$v)
      },
      expression: "company.deliveryPostalCodes"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    staticClass: "required",
    attrs: {
      "label": _vm.$lang.labels.chargeType,
      "items": _vm.chargeTypesFormatted,
      "item-text": "text",
      "item-value": "value",
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingChargeType)); }]
    },
    model: {
      value: (_vm.company.deliveryCharges.type),
      callback: function($$v) {
        _vm.$set(_vm.company.deliveryCharges, "type", $$v)
      },
      expression: "company.deliveryCharges.type"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.company.deliveryCharges.type === 'chargespermile') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "required",
    attrs: {
      "label": _vm.company.distanceUnit === 'meters' ? _vm.$lang.labels.delChargePerMeter : _vm.$lang.labels.delChargePerMile,
      "required": "",
      "step": "0.5",
      "min": "0",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingChargePerMile)); }],
      "type": "number"
    },
    model: {
      value: (_vm.company.deliveryCharges.chargesPerMile),
      callback: function($$v) {
        _vm.$set(_vm.company.deliveryCharges, "chargesPerMile", $$v)
      },
      expression: "company.deliveryCharges.chargesPerMile"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.company.deliveryCharges.type === 'chargesbymiles') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingMiles
    },
    on: {
      "click": _vm.addMiles
    }
  }, [_vm._v(_vm._s(_vm.company.distanceUnit === 'meters' ? _vm.$lang.actions.chargebyMeters : _vm.$lang.actions.chargebyMiles))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.company.distanceUnit === 'meters' ? _vm.$lang.header.fromMeters : _vm.$lang.header.fromMiles)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.company.distanceUnit === 'meters' ? _vm.$lang.header.toMeters : _vm.$lang.header.toMiles)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.charges)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', [_c('v-text-field', {
    staticClass: "required",
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "min": "0",
      "steps": "0.1",
      "label": _vm.$lang.header.defaultCharges,
      "hide-details": ""
    },
    model: {
      value: (_vm.defaultCharges),
      callback: function($$v) {
        _vm.defaultCharges = $$v
      },
      expression: "defaultCharges"
    }
  })], 1)])]), _vm._v(" "), (_vm.miles.length !== 0) ? _c('tbody', _vm._l((_vm.miles), function(charge, index) {
    return _c('tr', {
      key: index
    }, [(charge.isEdit) ? [_c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempMiles.fromMiles),
        callback: function($$v) {
          _vm.$set(_vm.tempMiles, "fromMiles", $$v)
        },
        expression: "tempMiles.fromMiles"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempMiles.toMiles),
        callback: function($$v) {
          _vm.$set(_vm.tempMiles, "toMiles", $$v)
        },
        expression: "tempMiles.toMiles"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempMiles.charges),
        callback: function($$v) {
          _vm.$set(_vm.tempMiles, "charges", $$v)
        },
        expression: "tempMiles.charges"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempMiles.fromMiles || !_vm.tempMiles.toMiles || !_vm.tempMiles.charges
      },
      on: {
        "click": function($event) {
          return _vm.saveMilesEdit(charge)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeMilesEdit(charge)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(charge.fromMiles))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.toMiles))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(charge.charges))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": _vm.editingMiles
      },
      on: {
        "click": function($event) {
          return _vm.editMiles(charge)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteMiles(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0) : _vm._e()])])], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.company.deliveryCharges.type === 'chargesbyinvoiceamount') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": _vm.editingAmount
    },
    on: {
      "click": _vm.addAmount
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.chargebyAmount))]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow custom-table"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.fromAmount)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.toAmount)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "th-adj"
  }, [_vm._v(_vm._s(_vm.$lang.header.charges)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('th', [_c('v-text-field', {
    staticClass: "required",
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "min": "0",
      "steps": "0.1",
      "label": _vm.$lang.header.defaultCharges,
      "hide-details": ""
    },
    model: {
      value: (_vm.defaultCharges),
      callback: function($$v) {
        _vm.defaultCharges = $$v
      },
      expression: "defaultCharges"
    }
  })], 1)])]), _vm._v(" "), (_vm.amounts.length !== 0) ? _c('tbody', _vm._l((_vm.amounts), function(amount, index) {
    return _c('tr', {
      key: index
    }, [(amount.isEdit) ? [_c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempAmount.fromAmount),
        callback: function($$v) {
          _vm.$set(_vm.tempAmount, "fromAmount", $$v)
        },
        expression: "tempAmount.fromAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempAmount.toAmount),
        callback: function($$v) {
          _vm.$set(_vm.tempAmount, "toAmount", $$v)
        },
        expression: "tempAmount.toAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.5"
      },
      model: {
        value: (_vm.tempAmount.charges),
        callback: function($$v) {
          _vm.$set(_vm.tempAmount, "charges", $$v)
        },
        expression: "tempAmount.charges"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempAmount.fromAmount || !_vm.tempAmount.toAmount || !_vm.tempAmount.charges
      },
      on: {
        "click": function($event) {
          return _vm.saveAmountEdit(amount)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeAmountEdit(amount)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(amount.fromAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(amount.toAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(amount.charges))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editAmount(amount)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteAmount(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0) : _vm._e()])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.header.automatedPrinting) + "\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.printingConfigurations,
      "rows-per-page-items": [25, 50, 100, 200, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.sourceSystem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.orderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.printType))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "40px"
          }
        }, [_c('v-checkbox', {
          attrs: {
            "disabled": _vm.company.address.country === 'AT' && props.item.printType === 'invoice',
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.item.autoPrinting),
            callback: function($$v) {
              _vm.$set(props.item, "autoPrinting", $$v)
            },
            expression: "props.item.autoPrinting"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "px-3 pb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.header.keys) + "\n          ")])]), _vm._v(" "), (_vm.company.contactServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.contactServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.contactServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.contactServerSettings, "key", $$v)
      },
      expression: "company.contactServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.walletServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.walletServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.walletServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.walletServerSettings, "key", $$v)
      },
      expression: "company.walletServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.addressServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.addressServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.addressServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.addressServerSettings, "key", $$v)
      },
      expression: "company.addressServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.inventoryServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.inventoryServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.inventoryServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.inventoryServerSettings, "key", $$v)
      },
      expression: "company.inventoryServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company.reservationServerSettings) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.reservationServerSettings,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.reservationServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.reservationServerSettings, "key", $$v)
      },
      expression: "company.reservationServerSettings.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": "",
      "shrink": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$lang.labels.enableDEP,
      "readonly": _vm.company.address.country === 'UK',
      "color": "primary"
    },
    model: {
      value: (_vm.company.isDEPEnabled),
      callback: function($$v) {
        _vm.$set(_vm.company, "isDEPEnabled", $$v)
      },
      expression: "company.isDEPEnabled"
    }
  })], 1), _vm._v(" "), (_vm.company.isDEPEnabled) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.depServerKey,
      "color": "primary",
      "auto-grow": "",
      "box": "",
      "rows": "2"
    },
    model: {
      value: (_vm.company.depServerSettings.key),
      callback: function($$v) {
        _vm.$set(_vm.company.depServerSettings, "key", $$v)
      },
      expression: "company.depServerSettings.key"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "px-3": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3",
    attrs: {
      "justify-space-between": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'companies'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.cancel) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.checkValidation) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit('pushConfig')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.pushConfUpdate) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "type": "submit",
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "timeout": _vm.timeout,
      "color": "error",
      "multi-line": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$lang.labels.maxDeliveryDisWarning) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")])], 1), _vm._v(" "), (_vm.validateModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.validateModal),
      callback: function($$v) {
        _vm.validateModal = $$v
      },
      expression: "validateModal"
    }
  }, [_c('validate-modal', {
    attrs: {
      "companyId": _vm.companyId
    },
    on: {
      "close": function($event) {
        _vm.validateModal = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.createCorporationDialog) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.createCorporationDialog),
      callback: function($$v) {
        _vm.createCorporationDialog = $$v
      },
      expression: "createCorporationDialog"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": 'Create Corporation?'
    },
    on: {
      "submit": function($event) {
        return _vm.createCorporation()
      },
      "close": function($event) {
        _vm.createCorporationDialog = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addressDialog) ? _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "max-width": "600px"
    },
    model: {
      value: (_vm.addressDialog),
      callback: function($$v) {
        _vm.addressDialog = $$v
      },
      expression: "addressDialog"
    }
  }, [_c('address-modal', {
    attrs: {
      "country": _vm.company.address.country,
      "address": _vm.company.address,
      "postal": _vm.company.address.postalcode
    },
    on: {
      "close": function($event) {
        _vm.addressDialog = false
      },
      "submit": _vm.submitAddress
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a604f8b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/CompanyDetails.vue
// module id = 427
// module chunks = 35